import { useCallback } from 'react';
import { AnalyticsUserContextResponse } from '@src/@types/analytics-user';
import { useFetch } from '@src/hooks/use-fetch.hook';

export const useAnalyticsUserContextApi = () => {
  const fetch = useFetch();
  const fetchAnalyticsUserContext = useCallback(async () => {
    const res = await fetch(
      '/app/rest/user-context?pageType=pet_insurance',
      {
        method: 'GET',
      },
      {
        loginRedirect: false,
      },
    );
    if (!res.ok) {
      throw new Error(`Error Fetching Analytics User Context: ${res.status}`);
    }
    return (await res.json()) as AnalyticsUserContextResponse;
  }, [fetch]);
  return { fetchAnalyticsUserContext };
};
